import type { CachedOrg } from '@bb/automaton';
import type { IGenericUser } from '@bb/users';

export default (
  user: Pick<IGenericUser, 'location' | 'address'> & {
    org: Pick<CachedOrg, 'addresses'>;
  },
) => user.org.addresses[Number(user.location)][Number(user.address)];
